import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const makeReadOnlyEmailField = email => () => /*#__PURE__*/_jsx(UIFormControl, {
  label: I18n.text('EmailComponents.export.emailFieldLabel'),
  children: /*#__PURE__*/_jsx(UITextInput, {
    readOnly: true,
    value: email
  })
});
export default makeReadOnlyEmailField;